import { useState } from "react";
import { zones } from "@/mocks/guaNews";

const flashMock = [
  { tag: "影视圈", title: "《拾光来信》主创同框路透流出", time: "刚刚" },
  { tag: "综艺咖", title: "跨年晚会拟邀名单第三版流出", time: "5 分钟前" },
  { tag: "饭圈热", title: "颁奖季红毯造型预测贴破万楼", time: "12 分钟前" },
  { tag: "现场派", title: "某歌手巡演加场开票三分钟售罄", time: "20 分钟前" },
  { tag: "时尚风", title: "时尚周看秀生图造型被逐帧讨论", time: "35 分钟前" },
  { tag: "话题池", title: "经典剧重播翻红带动二创热潮", time: "48 分钟前" },
];

export default function Zones() {
  const [active, setActive] = useState("all");
  const allZones = [{ id: "all", name: "全部专区", emoji: "🔁", color: "bg-primary-500", text: "text-background-50", count: "5,623 条", hot: "今日 +537" }, ...zones];

  const current = allZones.find((z) => z.id === active) || allZones[0];

  return (
    <section id="zones" className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h4 className="text-sm font-semibold text-secondary-700">
              <a href="#zones" className="inline-flex items-center gap-1.5">
                <i className="ri-earth-line text-base"></i>
                Across the Web
              </a>
            </h4>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">全网专区 · 今日速览</h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
              按题材划分专区，各区的今日动态聚合在一处，切换即可快速扫完，不用四处翻帖子。
            </p>
          </div>
        </div>

        {/* zone chips */}
        <div className="mt-6 flex flex-wrap gap-2">
          {allZones.map((z) => (
            <button
              key={z.id}
              onClick={() => setActive(z.id)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === z.id
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-50 text-foreground-700 ring-1 ring-inset ring-background-200 hover:bg-background-200/60"
              }`}
            >
              <span>{z.emoji}</span>
              {z.name}
            </button>
          ))}
        </div>

        <div className="mt-6 grid gap-5 lg:grid-cols-[280px_1fr]">
          {/* left meta card */}
          <div className="rounded-2xl bg-background-50 p-5 ring-1 ring-inset ring-background-200/70">
            <span className={`inline-flex items-center justify-center rounded-lg p-2 text-lg ${current.color} ${current.text}`}>
              {current.emoji}
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950">{current.name}</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-600">
              {current.name === "全部专区" ? "汇总六大题材的最新动态，一条不漏地聚合展示。" : `${current.name}的今日热点聚合，聚焦本区讨论风向。`}
            </p>
            <dl className="mt-5 space-y-2 text-sm">
              <div className="flex items-center justify-between">
                <dt className="text-foreground-500">累计内容</dt>
                <dd className="font-semibold text-foreground-950">{current.count}</dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="text-foreground-500">今日热度</dt>
                <dd className="font-semibold text-primary-700">{current.hot}</dd>
              </div>
            </dl>
          </div>

          {/* flash list */}
          <div className="divide-y divide-background-200/70 rounded-2xl bg-background-50 ring-1 ring-inset ring-background-200/70">
            {flashMock.map((f, i) => (
              <a key={i} href="#flash" className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/60">
                <span className="flex h-2 w-2 shrink-0 rounded-full bg-accent-500"></span>
                <span className="hidden w-20 shrink-0 whitespace-nowrap rounded-md bg-background-100 px-2 py-1 text-center text-xs font-medium text-foreground-600 sm:inline-block">
                  {f.tag}
                </span>
                <span className="min-w-0 flex-1 truncate text-[15px] font-medium text-foreground-800 group-hover:text-primary-700">
                  {f.title}
                </span>
                <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  {f.time}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}